import { connect } from 'react-redux';
import { resolveInvite, clearInvite } from '../actions/guest';
import Guest from '../components/guest/guest';

function mapStateToProps({ guest, devices }) {
  return {
    invite: guest.invite,
    pairedDevices: devices.pairedDevices,
    pairing: devices.pairing,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resolveInvite: inviteId => dispatch(resolveInvite(inviteId)),
    clearInvite: () => dispatch(clearInvite()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Guest);



// WEBPACK FOOTER //
// ./src/containers/guest.js